var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',_vm._b({directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.imageUrl(_vm.photo)),expression:"imageUrl(photo)"}],class:_vm.image_class,attrs:{"alt":_vm.name,"title":_vm.name,"src":_vm.imgNotLoad}},'img',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }